import { defineMessages } from 'react-intl';
export default defineMessages({
  show: {
    id: 'comp.pager.show',
    defaultMessage: 'Show {items}',
  },
});
